import { actions } from "@ehi/global-marketing-interface";

export const clearPartnerRewardsState = () => (dispatch) => {
    dispatch(actions.reservations.commitState.unset('partner_reward_program_code'));
    dispatch(actions.reservations.commitState.unset('partner_reward_program_member_id'));
};